/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Cmp_Meta_TitleInputs */

const en_cmp_meta_title = /** @type {(inputs: Cmp_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bystep vs ${i?.name}`)
};

const id_cmp_meta_title = /** @type {(inputs: Cmp_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bystep vs ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Bystep vs {name}" |
*
* @param {Cmp_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cmp_meta_title = /** @type {((inputs: Cmp_Meta_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmp_Meta_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cmp_meta_title(inputs)
	return en_cmp_meta_title(inputs)
});